import { DateRangeType } from 'modules/dashboard/types/phlebotomist-dashboard';

export function isCurrentPeriod(dateRange: DateRangeType): boolean {
  return [
    'day',
    'week',
    'month',
    'quarter',
    'year',
    'dayCal',
    'weekCal',
    'monthCal',
    'quarterCal',
    'yearCal',
  ].includes(dateRange);
}
